// Display labels for BKG filter schema paths and values.

const LABEL_OVERRIDES: Record<string, string> = {
  "value.check_size_usd": "Check Size (USD)",
  "value.check_size_usd.value": "Check Size (USD)",
  "value.average_check_size_usd.value": "Average Check Size (USD)",
  "value.aum_usd.value": "AUM (USD)",
  "value.stage_focus.value": "Stage Focus",
  "value.investment_style.value": "Investment Style",
  "value.internal_dev_capabilities.value": "Internal Capabilities",
  source_date: "Report Date",
  "value.date": "Event Date",
  "value.focus_sectors": "Focus Sectors",
  "value.focus_sectors.value.sector": "Focus Sector",
  "value.focus_sectors.value.sector.value": "Focus Sector",
  "value.focus_sectors.value.bio_specific": "Biotech Focus",
  "value.focus_sectors.value.bio_specific.value": "Biotech Focus",
  "value.active_fund": "Active Fund",
  "value.active_fund.value.vintage_year": "Fund Vintage Year",
  "value.active_fund.value.vintage_year.value": "Fund Vintage Year",
  "value.active_fund.value.size_usd": "Fund Size (USD)",
  "value.active_fund.value.size_usd.value": "Fund Size (USD)",
  "value.active_funds": "Active Funds",
  "value.active_funds.value": "Active Funds",
  "value.active_funds.value.name": "Fund Name",
  "value.active_funds.value.name.value": "Fund Name",
  "value.active_funds.value.vintage_year": "Fund Vintage Year",
  "value.active_funds.value.vintage_year.value": "Fund Vintage Year",
  "value.active_funds.value.size_usd": "Fund Size (USD)",
  "value.active_funds.value.size_usd.value": "Fund Size (USD)",
  "value.active_funds.value.size_usd.value.min": "Minimum Fund Size (USD)",
  "value.active_funds.value.size_usd.value.max": "Maximum Fund Size (USD)",
  "value.exit_value_usd": "Exit Value (USD)",
  "value.exit_value_usd.value": "Exit Value (USD)",
  "value.exit_value_usd.value.min": "Minimum Exit Value (USD)",
  "value.exit_value_usd.value.max": "Maximum Exit Value (USD)",
  "value.exit_value_usd.value.min.value": "Minimum Exit Value (USD)",
  "value.exit_value_usd.value.max.value": "Maximum Exit Value (USD)",
  "value.notable_biotech_exits.value": "Notable biotech exits",
  "value.notable_biotech_exits.value.exit_type.value": "Exit type",
  "value.notable_biotech_exits.value.exit_value_usd.value": "Exit value (USD)",
  // Primary facets show without their group, so their labels carry its sense.
  "value.latest_funding.value.amount": "Latest funding",
  "value.attendance.value.event_name": "Conference",
  "value.ssi_connections.value.strength": "SSI connections",
  company_entity_type: "Public or private",
  "value.type": "Event type",
  "value.company_name": "Company",
  "value.company_name.value.name": "Company name",
};

export const renderPath = (path: string): string => {
  if (path.trim() === "value") return "Filters";

  const cleaned = path.endsWith(".value")
    ? path.slice(0, -".value".length)
    : path;
  if (LABEL_OVERRIDES[cleaned]) {
    return LABEL_OVERRIDES[cleaned];
  }

  const segments = cleaned.split(".");
  const lastSegment = segments[segments.length - 1];
  if (LABEL_OVERRIDES[lastSegment]) {
    return LABEL_OVERRIDES[lastSegment];
  }

  return lastSegment.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
};

const compactNumber = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

// "$5M" for a USD field, "5K" for anything else.
export const formatAmount = (n: number, path: string): string =>
  `${/usd/i.test(path) ? "$" : ""}${compactNumber.format(n)}`;

export const toLabel = (
  value: string | number | boolean,
  isBoolean: boolean,
): string => {
  if (isBoolean) return value === true ? "Yes" : "No";
  return typeof value === "string" ? value : String(value);
};
